
document.addEventListener('click', (event) => {
  const thumb = event.target.closest('[data-product-thumb]');
  if (thumb) {
    const main = document.querySelector('[data-main-product-image]');
    if (main && thumb.dataset.image) {
      main.src = thumb.dataset.image;
      main.alt = thumb.dataset.alt || '';
      document.querySelectorAll('[data-product-thumb]').forEach(el => el.classList.remove('active'));
      thumb.classList.add('active');
    }
  }

  const swatch = event.target.closest('[data-variant-option]');
  if (swatch) {
    const group = swatch.closest('[data-option-position]');
    group.querySelectorAll('[data-variant-option]').forEach(el => el.classList.remove('active'));
    swatch.classList.add('active');
    updateVariant();
  }
});

function selectedOptions() {
  return [...document.querySelectorAll('[data-option-position]')].map(group => {
    const active = group.querySelector('[data-variant-option].active');
    return active ? active.dataset.value : null;
  });
}

function updateVariant() {
  const data = window.SewSheekProduct;
  if (!data) return;

  const chosen = selectedOptions();
  const variant = data.variants.find(v =>
    chosen.every((value, index) => value === null || v.options[index] === value)
  );

  const add = document.querySelector('[data-add-to-cart]');
  if (!variant) {
    if (add) { add.disabled = true; add.textContent = 'Unavailable'; }
    return;
  }

  const id = document.querySelector('[data-variant-id]');
  const price = document.querySelector('[data-variant-price]');
  if (id) id.value = variant.id;
  if (price) price.textContent = variant.price;
  if (add) {
    add.disabled = !variant.available;
    add.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
  }

  if (variant.image) {
    const main = document.querySelector('[data-main-product-image]');
    if (main) main.src = variant.image;

    let found = false;
    document.querySelectorAll('[data-product-thumb]').forEach(el => {
      const isMatch = String(el.dataset.mediaId) === String(variant.mediaId);
      el.classList.toggle('active', isMatch);
      if (isMatch) found = true;
    });
  }

  const url = new URL(window.location.href);
  url.searchParams.set('variant', variant.id);
  history.replaceState({}, '', url);
}

document.addEventListener('DOMContentLoaded', updateVariant);
